import React from "react";

export default function ErrorPage() {
  return (
    <div>
      <h1>Error 404 page not found!</h1>
    </div>
  );
}
